// src/components/AdminRoutes.js - Component for integrating admin routes with proper authentication
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import AdminLayout from './admin/AdminLayout';
import AdminDashboard from './admin/AdminDashboard';
import UserManagement from './admin/UserManagement';
import EnvironmentManagement from './admin/EnvironmentManagement';
import AuthorizationManagement from './admin/AuthorizationManagement';
import AdminSettings from './admin/AdminSettings';
import BusinessCentralService from '../services/businessCentralService';

const AdminRoutes = () => {
  const { user, getAccessToken, isAuthenticated } = useAuth();
  const isAdmin = user?.isAdmin === true;
  
  // Create BC service for admin components
  const bcService = React.useMemo(() => {
    return new BusinessCentralService(getAccessToken);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  // If authenticated but not admin, redirect to portal
  if (!isAdmin) {
    return <Navigate to="/portal" />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<AdminLayout />}>
        <Route index element={<Navigate to="/admin/dashboard" />} />
        <Route path="dashboard" element={<AdminDashboard bcService={bcService} />} />
        <Route path="users" element={<UserManagement bcService={bcService} />} />
        <Route path="environments" element={<EnvironmentManagement bcService={bcService} />} />
        <Route path="authorization" element={<AuthorizationManagement bcService={bcService} />} />
        <Route path="settings" element={<AdminSettings bcService={bcService} />} />
        <Route path="*" element={<Navigate to="/admin/dashboard" />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;